// Consent-aware analytics - must load before any tracking scripts
import './js/analytics/consent-datalayer-manager.js';
import './dayjs.js';

import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';

import 'core-js/actual/structured-clone';
import './js/sentry.js';
import './css/main.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/reprise/stimulus';

import CurrencyStoreController from './svelte/saga/controllers/CurrencyStoreController.svelte';
// Import Svelte components individually
import TourAsidePanel from './svelte/saga/controllers/TourAsidePanel.svelte';
import TourFitVisibleDatesController from './svelte/saga/controllers/TourFitVisibleDatesController.svelte';
import TourGirVisibleDatesController from './svelte/saga/controllers/TourGirVisibleDatesController.svelte';
import TourSnowtrexVisibleDatesController from './svelte/saga/controllers/TourSnowtrexVisibleDatesController.svelte';

Turbo.session.drive = false;

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
startStimulusApp();

// Create a custom context function that behaves like import.meta.webpackContext for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = {
    './TourAsidePanel.svelte': { default: TourAsidePanel },
    './TourGirVisibleDatesController.svelte': {
        default: TourGirVisibleDatesController,
    },
    './TourFitVisibleDatesController.svelte': {
        default: TourFitVisibleDatesController,
    },
    './TourSnowtrexVisibleDatesController.svelte': {
        default: TourSnowtrexVisibleDatesController,
    },
    './CurrencyStoreController.svelte': {
        default: CurrencyStoreController,
    },
};

customContext.keys = function () {
    return Object.keys(this._components);
};

// Register our Svelte components
registerSvelteControllerComponents(customContext);
